import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const OneOneTwoOneOneDrill = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === '1-1-2-1-1-drill');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default OneOneTwoOneOneDrill;
